import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, catchError, map } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderGuard {
  constructor(private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const providerId = route.paramMap.get('providerId');

    return this.authService.checkAndInitiateSSOLogin({ providerId }).pipe(
      map((isSSO) => {
        if (!isSSO) {
          // password-type provider — send user to standard login
          this.navigateToLogin();
        }
        // SSO path: browser is already redirecting via window.location.href
        return false; // always cancel Angular route activation; navigation is handled above
      }),
      catchError(() => {
        this.navigateToLogin();
        return of(false);
      })
    );
  }

  /**
   * Hard-navigates to the login page via window.location.href (full page reload).
   * This is intentional: a client-side router.navigate() would not re-run the
   * index.html scripts, leaving the cookie consent banner suppressed (it was hidden
   * for the provider route). A full reload ensures the banner evaluates fresh against
   * the login URL and appears correctly if the user has not yet consented.
   */
  private navigateToLogin(): void {
    const lang = localStorage.getItem('lang');
    const loginPath = lang === 'fr' ? '/principale/connexion' : '/main/login';
    window.location.href = window.location.origin + loginPath;
  }
}
